import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Clock, Wifi, BadgeIndianRupee, ArrowRight } from "lucide-react";

export const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="courses-page">
      <span className="eyebrow">Our Programs</span>
      <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
        Courses designed to launch careers in medical devices.
      </h1>
      <p className="mt-5 text-lg text-slate-600 max-w-2xl">
        Short, focused and built around the real-world skills hospitals and biomedical
        companies hire for.
      </p>

      <div className="mt-12 grid md:grid-cols-2 gap-8" data-testid="courses-list">
        {loading && <p className="text-slate-500">Loading courses…</p>}
        {!loading && courses.length === 0 && (
          <p className="text-slate-500">No courses available yet.</p>
        )}
        {courses.map((c) => (
          <div key={c.slug} className="card-soft flex flex-col" data-testid={`course-card-${c.slug}`}>
            <span className="eyebrow">Flagship</span>
            <h3 className="mt-3 font-heading text-2xl font-semibold text-[#0A3B32]">{c.title}</h3>
            <p className="mt-3 text-slate-600 leading-relaxed flex-1">{c.tagline}</p>
            <div className="mt-6 grid grid-cols-3 gap-3 text-center">
              <div className="rounded-lg bg-slate-50 p-3">
                <Clock size={16} className="mx-auto text-[#0A3B32]" />
                <p className="mt-1 text-xs text-slate-500">Duration</p>
                <p className="text-sm font-semibold">{c.duration.split("(")[0].trim()}</p>
              </div>
              <div className="rounded-lg bg-slate-50 p-3">
                <Wifi size={16} className="mx-auto text-[#0A3B32]" />
                <p className="mt-1 text-xs text-slate-500">Mode</p>
                <p className="text-sm font-semibold">{c.mode}</p>
              </div>
              <div className="rounded-lg bg-slate-50 p-3">
                <BadgeIndianRupee size={16} className="mx-auto text-[#C85A40]" />
                <p className="mt-1 text-xs text-slate-500">Reserve</p>
                <p className="text-sm font-semibold text-[#C85A40]">Free</p>
              </div>
            </div>
            <Link
              to={`/courses/${c.slug}`}
              className="btn-primary mt-6"
              data-testid={`course-cta-${c.slug}`}
            >
              View Details <ArrowRight size={18} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
